var _circle, _path, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 54 58",
    width: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9989,
    cy: 25.0004,
    r: 23.8046,
    stroke: "#f55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m27 5.92508c-10.5348 0-19.07492 8.54012-19.07492 19.07492s8.54012 19.0749 19.07492 19.0749 19.0749-8.5401 19.0749-19.0749-8.5401-19.07492-19.0749-19.07492zm-24 19.07492c0-13.2548 10.7452-24 24-24s24 10.7452 24 24-10.7452 24-24 24-24-10.7452-24-24z",
    fill: "#f55",
    fillRule: "evenodd",
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9998,
    cy: 25.0003,
    r: 19.2704,
    stroke: "#f55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.0225 23.3779c0-2.2091 1.7908-4 4-4h9.9554c2.2091 0 4 1.7909 4 4v8.9579c0 2.2092-1.7909 4-4 4h-9.9554c-2.2092 0-4-1.7908-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.0127 16.3851c0-2.7546 2.233-4.9876 4.9876-4.9876 2.7546 0 4.9876 2.233 4.9876 4.9876v2.9926h-9.9752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.0003 29.3528c1.6527 0 2.9925-1.3398 2.9925-2.9926 0-1.6527-1.3398-2.9925-2.9925-2.9925-1.6528 0-2.9926 1.3398-2.9926 2.9925 0 1.6528 1.3398 2.9926 2.9926 2.9926zm0 0v2.9926"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/Icon-Secure.a2bca7a710c6f1c8839fb3629ebc5662.svg";
export { ForwardRef as ReactComponent };